"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BitcoinCircleSolid: function() {
        return BitcoinCircleSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const BitcoinCircleSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M15 14C15 14.5523 14.5523 15 14 15H11V13H14C14.5523 13 15 13.4477 15 14Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M11 11V9H14C14.5523 9 15 9.44771 15 10C15 10.5523 14.5523 11 14 11H11Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM9 9H8.5C7.94772 9 7.5 8.55228 7.5 8C7.5 7.44772 7.94772 7 8.5 7H9V6.5C9 5.94772 9.44771 5.5 10 5.5C10.5523 5.5 11 5.94772 11 6.5V7H12V6.5C12 5.94772 12.4477 5.5 13 5.5C13.5523 5.5 14 5.94772 14 6.5V7C15.6569 7 17 8.34315 17 10C17 10.7684 16.7111 11.4692 16.2361 12C16.7111 12.5308 17 13.2316 17 14C17 15.6569 15.6569 17 14 17V17.5C14 18.0523 13.5523 18.5 13 18.5C12.4477 18.5 12 18.0523 12 17.5V17H11V17.5C11 18.0523 10.5523 18.5 10 18.5C9.44771 18.5 9 18.0523 9 17.5V17H8.5C7.94772 17 7.5 16.5523 7.5 16C7.5 15.4477 7.94772 15 8.5 15H9V9Z",
            fill: "currentColor"
        })
    ]
}), "BitcoinCircleSolid");
const _default = BitcoinCircleSolid;
